/* eslint-disable filenames/match-exported */

import Index from '~/views/Index';
export default Index;